import React from 'react';
import styled from '@emotion/styled';
import { css } from 'emotion';

import BFBLogo, { BFBLogoSmallOnPhone } from '../BFBLogo';
import DPLLogo, { DPLLogoSmallOnPhone } from '../DPLLogo';

import { mediaPhone } from '../styles/breakpoints';
import { HideLogoLabelOnPhoneStyles } from '../styles/Logo';

const Layout = styled.section`
  display: flex;
  justify-content: flex-end;
`;

const Logos = () => (
  <Layout>
    <BFBLogo
      labelStyles={HideLogoLabelOnPhoneStyles}
      imageStyles={BFBLogoSmallOnPhone}
    />
    <DPLLogo
      className={css({
        marginLeft: '93px',
        [mediaPhone]: {
          marginLeft: '52px',
        },
      })}
      labelStyles={css(HideLogoLabelOnPhoneStyles, 'text-align: right;')}
      imageStyles={DPLLogoSmallOnPhone}
    />
  </Layout>
);

export default Logos;



// WEBPACK FOOTER //
// ./src/components/PageHeader/Logos.js